/** Set on `document.documentElement` by Header `useHeaderOffset` (live measured height). */
export const SITE_HEADER_OFFSET_VAR = '--site-header-offset';

/** Measured from `#venue-section-nav` (sticky pill bar). */
export const VENUE_SECTION_NAV_ID = 'venue-section-nav';
export const VENUE_SECTION_NAV_HEIGHT_VAR = '--venue-section-nav-height';

/** Space between sticky nav bottom and section heading when scrolling. */
export const VENUE_SECTION_SCROLL_GAP_PX = 16;

const DEFAULT_HEADER_OFFSET_PX = 118;
const DEFAULT_VENUE_NAV_HEIGHT_PX = 60;

export function readSiteHeaderOffsetPx(fallback = DEFAULT_HEADER_OFFSET_PX) {
  if (typeof document === 'undefined') {
    return fallback;
  }
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue(SITE_HEADER_OFFSET_VAR)
    .trim();
  const parsed = parseFloat(raw);
  if (Number.isFinite(parsed) && parsed > 0) {
    return parsed;
  }
  return fallback;
}

export function readVenueSectionNavHeightPx(
  fallback = DEFAULT_VENUE_NAV_HEIGHT_PX,
) {
  if (typeof document === 'undefined') {
    return fallback;
  }
  const nav = document.getElementById(VENUE_SECTION_NAV_ID);
  if (nav) {
    return Math.ceil(nav.getBoundingClientRect().height);
  }
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue(VENUE_SECTION_NAV_HEIGHT_VAR)
    .trim();
  const parsed = parseFloat(raw);
  if (Number.isFinite(parsed) && parsed > 0) {
    return parsed;
  }
  return fallback;
}

export function syncVenueSectionNavHeightCssVar(heightPx) {
  if (typeof document === 'undefined' || heightPx == null) {
    return;
  }
  document.documentElement.style.setProperty(
    VENUE_SECTION_NAV_HEIGHT_VAR,
    `${Math.ceil(heightPx)}px`,
  );
}

/** Sticky section nav + gap — scroll targets align section titles below sticky nav bar. */
export function venueDetailScrollOffsetPx() {
  return (
    readVenueSectionNavHeightPx() +
    VENUE_SECTION_SCROLL_GAP_PX
  );
}

/** @deprecated use readVenueSectionNavHeightPx */
export const VENUE_SECTION_NAV_HEIGHT_PX = DEFAULT_VENUE_NAV_HEIGHT_PX;
